import script from "./BrandLogoOverridesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandLogoOverridesPage.vue?vue&type=script&setup=true&lang=ts"

import "./BrandLogoOverridesPage.vue?vue&type=style&index=0&id=d9f067ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9f067ec"]])

export default __exports__